import React from 'react';
import { node, bool } from 'prop-types';
import { Shelf, Text } from '@chaser/components';
import style from './BottomNotification.module.scss';
import SuspendedNotification from './SuspendedNotification';
import ConnectToAccountingNotification from './ConnectToAccountingNotification';
import PausedChasingNotification from './PausedChasingNotification';
import { Integrations, OpenAPIIntegrationTypes } from '../../util/constants';
import useFetch from '../../hooks/useFetch';
import OpenApiService from '../../services/openapi-service';
import NotificationPausedIcon from '../../assets/notification-bar/pause.svg';
import { useRouteMatch } from 'react-router-dom';

const Notification = ({ left, right, sidebarCollapsed = false, hasSidebar = true }) => {
  const sidebarWidth = !hasSidebar ? 0 : sidebarCollapsed ? 72 : 280;
  const wrapperStyle = { paddingLeft: `${sidebarWidth}px` };

  return (
    <Shelf className={style.notificationBoxWrapperDrm} style={wrapperStyle}>
      <Shelf className={style.notificationBoxDrm}>
        <Shelf justifyContent="space-between" width="100%" px="small" style={{ flexWrap: 'nowrap', alignItems: 'center' }}>
          <Shelf className={style.columns__left} style={{ flexWrap: 'nowrap' }}>
            <img src={NotificationPausedIcon} alt="" />
            <Text color="White" fontWeight="bold" style={{ whiteSpace: 'nowrap' }}>
              Chaser is paused
            </Text>
            <div className={style.middleText}>{left}</div>
          </Shelf>
          <Shelf className={style.columns__right} style={{ flexWrap: 'nowrap' }}>{right}</Shelf>
        </Shelf>
      </Shelf>
    </Shelf>
  );
};

const BottomNotification = ({
  isSuspended,
  expiredToken,
  noChase,
  accountingSoftware,
  integration,
  shortCode,
  lastRefreshDate,
  sidebarCollapsed = false,
  hasSidebar = true,
}) => {
  const isOpenApi = accountingSoftware === Integrations.OPENAPI;
  const { data: apiKeys } = useFetch(OpenApiService.getApiKeys, shortCode);
  const hasSynced = lastRefreshDate && lastRefreshDate !== new Date(0).toISOString();

  const welcomeMatch = useRouteMatch({
    path: ['/addorganisation/csvconfiguration', '/connect', '/select-organisations'],
    exact: false,
  });

  const cashFlowForecastMatch = useRouteMatch({
    path: ['/cashflow/forecast/table', '/cashflow/forecast/chart'],
    exact: false,
  });

  if (welcomeMatch || cashFlowForecastMatch) return null;

  const sharedProps = { sidebarCollapsed, hasSidebar };

  if (expiredToken) {
    return <ConnectToAccountingNotification accountingSoftware={accountingSoftware} {...sharedProps} />;
  }
  if (isOpenApi && ((!apiKeys.key && !apiKeys.secret) || !hasSynced)) {
    const integrationType = OpenAPIIntegrationTypes[integration] || Integrations.OPENAPI;
    return <ConnectToAccountingNotification accountingSoftware={integrationType} {...sharedProps} />;
  }
  if (isSuspended) {
    return <SuspendedNotification {...sharedProps} />;
  } else if (noChase) {
    return <PausedChasingNotification {...sharedProps} />;
  }

  return null;
};

Notification.propTypes = {
  left: node,
  right: node,
  sidebarCollapsed: bool,
  hasSidebar: bool,
};

export { BottomNotification };
export default Notification;
